"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setReferenceGrammarID;
exports.SET_REFERENCE_GRAMMAR_ID = void 0;
var SET_REFERENCE_GRAMMAR_ID = 'WEB_CHAT/SET_REFERENCE_GRAMMAR_ID';
exports.SET_REFERENCE_GRAMMAR_ID = SET_REFERENCE_GRAMMAR_ID;

function setReferenceGrammarID(referenceGrammarID) {
  return {
    type: SET_REFERENCE_GRAMMAR_ID,
    payload: {
      referenceGrammarID: referenceGrammarID
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldFJlZmVyZW5jZUdyYW1tYXJJRC5qcyJdLCJuYW1lcyI6WyJTRVRfUkVGRVJFTkNFX0dSQU1NQVJfSUQiLCJzZXRSZWZlcmVuY2VHcmFtbWFySUQiLCJyZWZlcmVuY2VHcmFtbWFySUQiLCJ0eXBlIiwicGF5bG9hZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLHdCQUF3QixHQUFHLG1DQUFqQzs7O0FBRWUsU0FBU0MscUJBQVQsQ0FBK0JDLGtCQUEvQixFQUFtRDtBQUNoRSxTQUFPO0FBQ0xDLElBQUFBLElBQUksRUFBRUgsd0JBREQ7QUFFTEksSUFBQUEsT0FBTyxFQUFFO0FBQUVGLE1BQUFBLGtCQUFrQixFQUFsQkE7QUFBRjtBQUZKLEdBQVA7QUFJRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNFVF9SRUZFUkVOQ0VfR1JBTU1BUl9JRCA9ICdXRUJfQ0hBVC9TRVRfUkVGRVJFTkNFX0dSQU1NQVJfSUQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZXRSZWZlcmVuY2VHcmFtbWFySUQocmVmZXJlbmNlR3JhbW1hcklEKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VUX1JFRkVSRU5DRV9HUkFNTUFSX0lELFxuICAgIHBheWxvYWQ6IHsgcmVmZXJlbmNlR3JhbW1hcklEIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VUX1JFRkVSRU5DRV9HUkFNTUFSX0lEIH07XG4iXX0=